export const GET_RELATIONSHIP = 'GET_RELATIONSHIP';
export const LOADING_RELATIONSHIP = 'LOADING_RELATIONSHIP';